/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import AddProduct from './addProduct.vue';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Group: Group,
    XButton: XButton,
    AddProduct: AddProduct
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    orderId: String,
    isSendRevised: Number,
    hasProduct: Array
  },
  data: function data() {
    return {
      currValue: this.value,
      isShowAddProduct: false,
      customerPro: [],
      is100h: false
    };
  },
  computed: {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 4 * fontSize;
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      if (val) {
        // this.$setLeft({
        //   control: true,
        //   onSuccess: () => {
        //     this.currValue = false
        //   }
        // })
        this.customerPro = this.hasProduct || [];
      } else {
        // this.$setLeft({ control: false })
        this.$emit('on-ok', this.customerPro);
      }
      this.$emit('input', val);
    },
    isShowAddProduct: function isShowAddProduct(val) {
      console.log(val);
      this.is100h = val;
    }
  },
  methods: {
    getCustomerPro: function getCustomerPro(e) {
      this.customerPro.push(_objectSpread({}, e));
      this.currValue = false;
    },
    sumbit: function sumbit() {
      if (!this.customerPro.length) return this.$vux.toast.text(i18n.tc("220"));
      this.$emit('on-ok', this.customerPro);
      this.currValue = false;
    },
    replaceMultiImg: function replaceMultiImg(urls) {
      if (!urls) return '';
      var urlArr = urls.split(',');
      return urlArr[0];
    }
  },
  created: function created() {}
};